<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section" id="sect9"><a id="page20"></a><span href="#/OEBPS/toc#sect9" title="Link target outside of Sample">Nutrient-Rich Kale Smoothie</span></h1>
<p class="figure"><img alt="" src="OEBPS/images/21-1.jpg" style="height:70vh"/></p>
<p class="RecipebYieldb">Yield: Serves 2 | Prep Time: 5 minutes | Cook Time: N/A</p>
<p class="extract_r">Kale is one of those superfoods you always hear so much about. The trick is figuring out how to incorporate it into your meals. I love this smoothie recipe since you can barely even taste the kale with all the yummy fruits inside.</p>
<p class="ingredients"><strong>INGREDIENTS</strong></p>
<p class="rec">2 cups fresh or frozen kale</p>
<p class="rec">½ large banana, sliced and frozen</p>
<p class="rec">½ cup frozen blueberries or mixed berries</p>
<p class="rec">½ cup frozen pineapple chunks</p>
<p class="rec">1 cup filtered water</p>
<p class="rec">2/3 cup 100 percent pomegranate juice</p>
<p class="rec">Juice of ½ lime</p>
<p class="directions"><strong>DIRECTIONS</strong></p>
<p class="recpr">1. Place the kale, banana, blueberries, pineapple chunks, filtered water, pomegranate juice, and lime juice in a blender.</p>
<p class="recpr">2. Blend until smooth. Pour into glasses and serve.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sect9.vue?41cf3f3e